// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Set up a RTK API to get Fund Data from Dataspan
export const fund = createApi({
  reducerPath: 'fund',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_API_URL}/funddetails/` }),
  endpoints: (builder) => ({
    getFundDetails: builder.query({
      query: (ticker) => `details/?ticker=${ticker}`,
    }),
    getNavDetails: builder.query({
      query: (ticker) => `nav/?ticker=${ticker}`,
    }),
    getRankings: builder.query({
      query: (ticker) => `rankings/?ticker=${ticker}`,
    }),
    getQuarterEndPerformance: builder.query({
      query: (ticker) => `quarter_end_performance/?ticker=${ticker}`,
    }),
    getMonthEndPerformance: builder.query({
      query: (ticker) => `month_end_performance/?ticker=${ticker}`,
    }),
    getCollateralText: builder.query({
      query: (ticker) => `collateral_text/?ticker=${ticker}`,
    }),
    getAggregates: builder.query({
      query: (ticker) => `aggregates/?ticker=${ticker}`,
    }),
    getAggregatesHistory: builder.query({
      query: (ticker) => `aggregates/?ticker=${ticker}&history=true`,
    }),
    getDistributions: builder.query({
      query: (ticker) => `distributions/?ticker=${ticker}`,
    }),
    getLiquidAssets: builder.query({
      query: (ticker) => `liquid_assets/?ticker=${ticker}`,
    }),
    getMoneyMarketHoldings: builder.query({
      query: (ticker) => `money_market_holdings/?ticker=${ticker}`,
    }),
  }),
});

export const {
  useGetFundDetailsQuery,
  useGetNavDetailsQuery,
  useGetRankingsQuery,
  useGetMonthEndPerformanceQuery,
  useGetQuarterEndPerformanceQuery,
  useGetCollateralTextQuery,
  useGetAggregatesQuery,
  useGetDistributionsQuery,
  useGetLiquidAssetsQuery,
  useGetMoneyMarketHoldingsQuery,
  useGetAggregatesHistoryQuery,
} = fund;
